import {Component, Input} from "@angular/core";
import {GeneralService} from "src/app/services/generalService";
import _ from "lodash";
import {DICTIONARY} from "../../../../dictionary";
import {NotificationService} from "../../../../services/notificationService";

@Component({
	selector: 'new-rule-condition-compromised',
	templateUrl: './account-compromised-new-rule-condition.component.html',
})

export class AccountCompromisedRulesConditionComponent{
	@Input('condition') conditionArr;
	@Input() conditionIndex;
	@Input() newRule;
	@Input() users;

	constructor(public gs:GeneralService,
				private ns:NotificationService) {
	}

	dic = DICTIONARY;
	rulesOptions = _.cloneDeep(this.dic.CONSTANTS.accountCompromisedRule);
	conditionTypes = _.cloneDeep(Object.values(this.dic.CONSTANTS.accountCompromisedRule.types));
	_=_;

	changeConditionType = (condition, type) => {
		if (condition.type === type)
			return;

		if (type === this.rulesOptions.types.target_users.name && this.conditionArr.length > 1) {
			this.ns.showWarnMessage('<b>Incident Target Users</b> is not allowed within OR condition.')
			return;
		}

		condition.type = type;
		condition.invalidConditionType = false;
		condition.is_negate = false;
		const incidentTypes = Object.keys(this.dic.CONSTANTS.accountCompromisedIncidentTypes).map(incidentTypeKey => ({
			key: incidentTypeKey,
			...this.dic.CONSTANTS.accountCompromisedIncidentTypes[incidentTypeKey]
		}));

		switch (condition.type) {
			case this.rulesOptions.types.incident_frequency.name:
				condition.data = {
					incidentCount: 5,
					hours: 1,
					incidentTypes,
				}
				break;

			case this.rulesOptions.types.incident_combination.name:
				condition.data = {
					hours: 1,
					incidentTypes
				}
				break;

			case this.rulesOptions.types.target_users.name:
				condition.data = {
					users: this.users.map(user => ({
						...user,
						selected: false,
					}))
				};
				break;
		}
	}

	cancelNewRuleCondition(conditionOrIndex, conditionArrIndexInRule) {
		if (this.conditionArr.length === 1) {
			const dataSrc = this.conditionArr[0].isException ? this.newRule.exceptions : this.newRule.conditions;
			dataSrc.splice(conditionArrIndexInRule, 1);
		}
		else {
			this.conditionArr.splice(conditionOrIndex, 1);
		}
	};
}
